import { fail, pass } from "../../buildResult";
import { defineTest } from "../../defineTest";
import { resolveTrace } from "../../helper/trace";

export default defineTest("trace_events_present", "Trace events loaded", ({ trace, fetchErrors }) => {
  const resolved = resolveTrace({ trace, fetchErrors });
  if (!resolved.ok) return resolved.result;

  const { events } = resolved;
  if (events.length === 0) {
    return fail("Trace has no events");
  }

  return pass(`${events.length} trace event(s) loaded`);
});
